module.exports = __webpack_public_path__ + "static/media/icon-scan.8ad1f570.svg";